export const API_DOMAIN = 'ya-praktikum.tech';
export const API_BASE_URL = `https://${API_DOMAIN}/api/v2`;
export const WS_CHATS_URL = `wss://${API_DOMAIN}/ws/chats`;
